import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\CancelSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CancelSupplierOrderController.php
* @route '/api/supplier-order/cancel/{supplier_order}'
*/
const CancelSupplierOrderController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: CancelSupplierOrderController.url(args, options),
    method: 'put',
})

CancelSupplierOrderController.definition = {
    methods: ["put"],
    url: '/api/supplier-order/cancel/{supplier_order}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\SupplierOrder\CancelSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CancelSupplierOrderController.php
* @route '/api/supplier-order/cancel/{supplier_order}'
*/
CancelSupplierOrderController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return CancelSupplierOrderController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\CancelSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CancelSupplierOrderController.php
* @route '/api/supplier-order/cancel/{supplier_order}'
*/
CancelSupplierOrderController.put = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: CancelSupplierOrderController.url(args, options),
    method: 'put',
})

export default CancelSupplierOrderController